export default __webpack_public_path__ + "static/interval-films-logo-3246269179e9eb6227ef773ac6d538de.png";